import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { GridFilterState } from './brick-filter-state/grid-filter.state';
import { BrickGridsState } from './brick-grids-state/brick-grids.state';
import { GridSortState } from './brick-sort-state/grid-sort.state';
import { BrickTabState } from './brick-tab-state/brick-tab.state';
import { AgentDetailsBehaviourState } from './brickTypes/agent-details-behavior/agent-details-behavior.state';
import { AgentListBehaviourState } from './brickTypes/agent-list-behaviour/agent-list-behaviour.state';
import { CallControlBehaviourState } from './brickTypes/call-control-behaviour/call-control-behaviour.state';
import { CallHistoryBrowserBehaviourState } from './brickTypes/call-history-browser-behaviour/call-history-browser-behaviour.state';
import { DirectoryBehaviourState } from './brickTypes/directory-behaviour/directory-behaviour.state';
import { DirectoryHelperState } from './brickTypes/directory-helper/directory-helper.state';
import { DynamicActionsBehaviorState } from './brickTypes/dynamic-actions-behavior/dynamic-actions-behavior.state';
import { GrafanaDashboardViewerBehaviourState } from './brickTypes/grafana-dashboard-viewer-behaviour/grafana-dashboard-viewer-behaviour.state';
import { SingleCallTagBehaviourState } from './brickTypes/single-call-tag-behaviour/single-call-tag-behaviour.state';
import { SkillBrowserBehaviourState } from './brickTypes/skill-browser-behaviour/skill-browser-behaviour.state';
import { TabBrickBehaviourState } from './brickTypes/tab-brick-behaviour/tab-brick-behaviour.state';
import { UserStatusBehaviourState } from './brickTypes/user-status-behaviour/user-status-behaviour.state';
import { WebViewerBehaviourState } from './brickTypes/webviewer-behaviour/webviewer-behaviour.state';

// tslint:disable-next-line:no-empty-interface
export interface BrickBehaviourStateStateModel {}

@State<BrickBehaviourStateStateModel>({
   name: 'brickBehaviourState',
   defaults: {},
   children: [
      WebViewerBehaviourState,
      UserStatusBehaviourState,
      TabBrickBehaviourState,
      TabBrickBehaviourState,
      SkillBrowserBehaviourState,
      SingleCallTagBehaviourState,
      GrafanaDashboardViewerBehaviourState,
      GridSortState,
      GridFilterState,
      DynamicActionsBehaviorState,
      DirectoryBehaviourState,
      DynamicActionsBehaviorState,
      DirectoryHelperState,
      CallHistoryBrowserBehaviourState,
      CallControlBehaviourState,
      BrickGridsState,
      BrickTabState,
      AgentListBehaviourState,
      AgentDetailsBehaviourState,
   ],
})
@Injectable()
export class BrickBehaviourStateState {}
